import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getQrIdByScan } from './api'
import { initialState, qrProps } from './types'

export const studentQrCodeSlice = createSlice({
    name: 'studentQrCode',
    initialState,
    reducers: {
        updateScannedQrid: (state, action: PayloadAction<any>) => {
            state.setSelectedQrId = action.payload
        }
    },
    extraReducers: {
        [getQrIdByScan.pending.toString()]: (state) => {
            state.isLoading = true
        },
        [getQrIdByScan.fulfilled.toString()]: (state, action: PayloadAction<qrProps>) => {
            state.isLoading = false
            state.getQrData = action.payload
        },
        [getQrIdByScan.rejected.toString()]: (state) => {
            state.isLoading = false
        }
    }
})

export default studentQrCodeSlice.reducer
